var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"none transparent"}},[(_vm.streamType==='detail4' || _vm.streamType==='detail1or2' )?_c('stream-details',{staticClass:"scale",style:(_vm.scaleStyle)}):(_vm.streamType==='total')?_c('stream-total',{staticClass:"scale",style:(_vm.scaleStyleTotal)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }